import { DestroyRef, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchInputService } from '@controls/form-search/search-input/search-input.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { FilterModel } from '@models/admin/filter.model';
import { saveAs } from 'file-saver';
import { AdminApiService } from '@services/admin/admin-api.service';

@Injectable()
export class DataService {

  private readonly http = inject(HttpClient);
  private readonly searchInputService = inject(SearchInputService);
  private readonly adminApiService = inject(AdminApiService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly destroy$ = inject(DestroyRef);

  id!: string | number;

  constructor() {
    this.activatedRoute.queryParams.pipe(
      takeUntilDestroyed(this.destroy$),
    ).subscribe((params) => {
      this.id = params['id'];
    });
  }

  getData(url: string, urlParams: any, page?: number, limit?: number, order?: any, filter?: FilterModel[], collectionId?: number): Observable<any> {
    const search = this.searchInputService.searchTerm;

    const requestBody: any = { page, limit, order, filter, collectionId };

    for (let key in urlParams)
      requestBody[key] = urlParams[key];

    if (search && !requestBody['search'])
      requestBody.search = search;

    if (url.includes('?')) {
      const parts = url.split('?');
      url = parts[0];
      const params = parts[1].split('&');

      params.forEach((param) => {
        const parts = param.split('=');
        requestBody[parts[0]] = parts[1];
      });
    }

    return this.http.post<any>('/' + url, requestBody);
  }

  sendData(url: string, data?: any, idName?: string): Observable<any> {
    if (idName && this.id)
      data[idName] = this.id;
    if (data['fileImage'] || data['file']) {
      const formData = new FormData();

      const keys = Object.keys(data);
      keys.forEach((key) => {
        formData.append(key, data[key]);
      });

      data = formData;
    }

    return this.http.post<any>('/' + url, data);
  }

  checkData(url: string, data?: any): Observable<any> {
    return this.http.post<any>('/' + url, data);
  }

  setRowsCount(rowsCount: number, tableName?: string) {
    if (!tableName)
      tableName = this.adminApiService.getSchemaName();
    return this.http.post('/profile/setTableRowsCount', { tableName, rowsCount });
  }

  setNotShownColumns(columns: string[], tableName?: string) {
    if (!tableName)
      tableName = this.adminApiService.getSchemaName();
    return this.http.post('/profile/setTableColumns', { tableName, columns });
  }

  downloadFile(url: string, data?: any) {
    const httpOptions = {
      observe: 'response',
      responseType: 'blob' as 'json',
    };

    // @ts-ignore
    return this.http.post('/' + url, data, httpOptions).subscribe((response: HttpResponse<Blob>) => {
      const fileName = response.headers.get('Content-Disposition')?.split('=')[1];

      const fileBlob = new Blob([response.body], { type: 'application/octet-stream' });
      saveAs(fileBlob, `${fileName}`);
    });
  }

  /*downloadFile(url: string, data?: any) {
    let params = new HttpParams();

    Object.keys(data).forEach(key => {
      params = params.set(key, data[key]);
    });

    const token = this.appStateService.token;
    if (token) {
      params = params.set('Authorization', 'Bearer ' + token);
    }

    const a = document.createElement('a');
    a.href = 'https://dev.lsbonus.com/' + url + '?' + params.toString();
    a.download = 'file';
    a.click();
    window.URL.revokeObjectURL(url);

    /!*return this.http.get('/' + url, { params,  responseType: 'blob', observe: 'response' }).pipe(
      map(response => {
        console.log(response);
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'downloaded-file';

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+?)"/);
          if (match && match[1])
            filename = match[1];
        }

        return { blob: response.body as Blob, filename };
      }),
    ).subscribe(({ blob, filename }) => {
      saveAs(blob, filename);
    });*!/

    /!*return this.http.get('/' + url, { params, responseType: 'blob' }).subscribe((response: Blob) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'file';
      a.click();
      window.URL.revokeObjectURL(url);
    });*!/
  }*/
}
